// Module
var code = "<h2 id=\"third-party-bill-payer\">Third-Party Bill-Payer</h2> <p>If you use a bill-pay service or pay through your bank, be sure they have our correct address, so your payment is sent to the right place. </p> ";
// Exports
export default code;